import {
	Client,
	ClientContact,
	MergeTagVariable,
	Opportunity,
	VendorClient,
	VendorClientContact,
	VendorCompany,
	VendorOpportunity,
	VendorPartner,
	ZomentumEntities
} from "..";

export enum ChangeSuggestionSource {
	Vendor = "vendor",
	Partner = "partner"
}

export enum ChangeSuggestionStatus {
	Requested = "requested",
	Accepted = "accepted",
	Rejected = "rejected"
}

export type SuggestedChange = Pick<
	MergeTagVariable,
	"variable_name" | "value" | "display_name" | "data_type"
>;

export type ParentEntityType = Client | VendorClient;

export type ChangeSuggestionEntityType =
	| Opportunity
	| Client
	| ClientContact
	| VendorOpportunity
	| VendorClient
	| VendorClientContact;

export enum ChangeSuggestionAction {
	CREATION = "creation",
	MODIFICATION = "modification"
}

export interface ChangeSuggestion {
	id: string;
	action: ChangeSuggestionAction;
	created: Date;
	updated: Date;
	deleted: false;
	company_id: string;
	vendor_company_id: string;
	source: ChangeSuggestionSource;
	entity_type: ZomentumEntities;
	entity_id: string;
	entity: ChangeSuggestionEntityType | null;
	parent_entity: ParentEntityType | null;
	status: ChangeSuggestionStatus;
	suggested_changes: SuggestedChange[];
	existing_values: SuggestedChange[];
	vendor_company?: VendorCompany | null;
	partner?: VendorPartner | null;
}

export interface ChangeSuggestionsResponse {
	data: ChangeSuggestion[];
}

export interface UpdateChangeSuggestionStatusRequest {
	status: ChangeSuggestionStatus;
}
